<template>
  <SystemInsightsActionModal
    :allSystemsEligibleText="allSystemsEligibleText"
    continueText="enable"
    :eligibleCount="eligibleCount"
    :eligibleDetailsText1="non64BitWarning"
    :eligibleDetailsText2="alreadyEnabledWarning"
    headerText="Enable System Insights"
    :ineligibleSystems="ineligibleSystems"
    :newState="newState"
    :noSystemsEligibleText="noSystemsEligibleText"
    :someSystemsEligibleText="someSystemsEligibleText"
    :warningText="warningText"
  />
</template>

<script>
import {
  ItemTypeConsts,
  StoreModuleMap,
  SystemInsightsConsts,
} from 'client/util/Constants';
import { mapGetters } from 'vuex';
import SystemInsightsActionModal from 'components/Modal/SystemInsightsActionModal.vue';
import pluralize from 'pluralize';

const storeModule = StoreModuleMap[ItemTypeConsts.system];

export default {
  name: 'SystemInsightsEnableModal',

  components: {
    SystemInsightsActionModal,
  },

  data: () => ({
    newState: SystemInsightsConsts.systemState.enabled,
  }),

  computed: {
    ...mapGetters(storeModule, {
      getIneligibleSystems: 'getSystemsIneligibleForSystemInsightEnablement',
      selectedItems: 'getSelectedItems',
    }),

    allSystemsEligibleText() {
      return `You've selected **${pluralize('system', this.selectedCount, true)}** to enable for System Insights.`;
    },

    alreadyEnabledWarning() {
      if (this.getIneligibleSystems.alreadyEnabledSystems.length > 0) {
        return `Already enabled systems (${pluralize('system', this.getIneligibleSystems.alreadyEnabledSystems.length, true)}) cannot be enabled.`;
      }

      return '';
    },

    eligibleCount() {
      return this.selectedCount - this.ineligibleSystems.length;
    },

    ineligibleSystems() {
      return this.getIneligibleSystems.alreadyEnabledSystems
        .concat(this.getIneligibleSystems.non64BitSystems);
    },

    noSystemsEligibleText() {
      return 'No selected systems are eligible to be enabled for System Insights.';
    },

    non64BitWarning() {
      if (this.getIneligibleSystems.non64BitSystems.length > 0) {
        return `32-bit systems (${pluralize('system', this.getIneligibleSystems.non64BitSystems.length, true)}) are **not eligible** for System Insights.`;
      }

      return '';
    },

    selectedCount() {
      return this.selectedItems.length;
    },

    someSystemsEligibleText() {
      return `${this.eligibleCount} of ${this.selectedCount} selected systems are eligible for System Insights.`;
    },

    warningText() {
      return `When System Insights is enabled, you will gain access to additional system information for the selected ${pluralize('system', this.eligibleCount)}. It may take a few minutes to begin populating data for online systems. Data for offline systems will become available once they have connected to a network.`;
    },
  },
};
</script>
